import axios from "axios";

export const getToken = () => {
  let token = sessionStorage.getItem("token");
  return token;
};

const attachAuthInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response) {
        const status = error.response.status;
        const errMsg = error.response.data?.errors || error.response.data?.message;
        if (
          status === 401 &&
          (errMsg === "This user has been deactivated by the Admin. Please contact your Admin." ||
            errMsg === "Please authenticate" ||
            errMsg === "Invalid User")
        ) {
          sessionStorage.clear();
          localStorage.clear();
          if (errMsg === "This user has been deactivated by the Admin. Please contact your Admin.") {
            alert(errMsg);
          }
          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export const getAxios = () => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  const instance = axios.create({ headers });
  return attachAuthInterceptor(instance);
};

export const getAxiosMultipart = () => {
  const token = getToken();
  const headers = { Authorization: `${token}` };
  const instance = axios.create({ headers });
  return attachAuthInterceptor(instance);
};
export function convertTo12HourFormat(time24Hour) {
  const [hours, minutes] = time24Hour.split(":").map(Number); // Parse hours and minutes as integers
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
}
